/* ==========================================================================
   Custom facets — sticky "is-stuck" state
   Adds .is-stuck to the filter/sort bar once it attaches under the sticky
   header, so CSS can show a white background + shadow. Pure CSS handles the
   sticky positioning; this only toggles the shadow class for polish.
   ========================================================================== */
(function () {
  function headerHeight() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    return parseInt(v, 10) || 0;
  }

  function observe(el) {
    if (!el || el.dataset.csfStick) return;
    el.dataset.csfStick = '1';

    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;left:0;width:1px;height:1px;pointer-events:none;visibility:hidden;';
    el.parentNode.insertBefore(sentinel, el);

    var io = new IntersectionObserver(
      function (entries) {
        el.classList.toggle('is-stuck', entries[0].intersectionRatio === 0);
      },
      { rootMargin: '-' + (headerHeight() + 1) + 'px 0px 0px 0px', threshold: [0, 1] }
    );
    io.observe(sentinel);
  }

  function init() {
    observe(document.querySelector('.facets-vertical-sort'));
    observe(document.querySelector('.facets-vertical .facets-wrapper'));
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
